// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__3KGOm","navbar":"navbar_navbar__w4MWc","navbar_links":"navbar_navbar_links__lII1-","active_link":"navbar_active_link__FDgDs"};